import React, { useEffect, useState, useRef, useContext } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { work_spaceActions, content_groupActions } from "../../../actions";
import ContentGroupList from "../ContentGroupPage/list";
import { Button } from 'react-bootstrap';
import EmptyStage from '../../../images/empty-stage.png';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { WorkspaceShowContext } from "../../../contexts/WorkspaceShowContext";
import { NEW_STAGE_MODAL_ACTIONS, stageConstants } from "../../../constants/stage.constants";
import handleDragEndCard from "../../../handlers/handleDragEndCard";
import { CardListHeader, CardStageList } from "../../../components/card_list_tab";

function ContentGroupsTables(props) {
  const {
    workspace_id,
    stages,
    handleShowNewForm,
    can_crud_content_group,
    handleInlineEdit,
    can_access_edit_title,
    can_access_assigned_user,
    can_access_show_content_details,
    can_access_move_content_list,
    can_access_add_change_date,
    can_access_approval_dots,
    can_access_edit_label,
    can_access_move_stage_board,
    replace_image
  } = props;

  const dispatch = useDispatch();
  const work_space = useSelector(state => state.work_space.currentWorkSpace);
  const rows = useSelector(state => state.stage.stages);
  const listTabRef = useRef(null);

  const {
    can_access_stage,
    getStages,
    updateRecords,
    nextPage,
    updated_at,
    addContentGroupToStage,
    removeContentGroupToStage
  } = useContext(WorkspaceShowContext);

  useEffect(() => {
    replace_image && replace_image.map((data, i) => {
      if(data && data.attachment) {
        var replaceImage = document.querySelector(`#find_div_${data.id} img:not(.drag-icon-image)`);
        if (!!replaceImage) {
          replaceImage.src = data.attachment.icon_square.url;
        }
      }
    })
  }, [replace_image, rows])

  useEffect(() => {
    const timer = setTimeout(() => {
      const visibleDivObserver = new IntersectionObserver((entries, imgObserver) => {
        var collect_id = []
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const find_value = entry.target
            if (find_value.getAttribute('data-image-pending') == 'true') {
              collect_id.push(find_value.getAttribute('data-id'));
              find_value.setAttribute('data-image-pending', 'false');
            }
          }
        })
        if(collect_id.length > 0) {
          var content_groups_id = collect_id
          dispatch(content_groupActions.replaceContentImageLazeLoading(workspace_id, content_groups_id ));
        }
      });

      var visible_div = document.querySelectorAll("#find_parentDiv > div > div > div > div .visible_div")
      visible_div.forEach((v) => {
        visibleDivObserver.observe(v);
      })
    }, 300);
    return () => clearTimeout(timer);
  }, [rows]);


  useEffect(() => {
    updateRecords(props);
  }, []);

  useEffect(() => {
    //updateRecords(props);
  }, [props.stages]);
  
  const onDragEnd = (result) => {
    handleDragEndCard({
      result,
      stages: rows,
      dispatch,
      workspace_id
    })
  }

  const setNewStageFormPopup = (e) => {
    e.preventDefault();
    
    const boundary = e.target.getBoundingClientRect();

    dispatch({ type: NEW_STAGE_MODAL_ACTIONS.OPEN_NEW_STAGE_MODAL, payload: boundary });
  }

  return (
    <div 
      id="find_parentDiv"
      ref={listTabRef}
      style={{ height: "100%", overflowY: "auto" }}
    >
      <CardListHeader scrollRef={listTabRef} />
      <div className="container layout__container-wrapper container--workspace-list">
         <DragDropContext  onDragEnd={onDragEnd}>
          <Droppable
            droppableId="LIST"
            type="COLUMN"
            direction="vertical"
          >
            {(provided, snapshot) => {
              return (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}>
                  { rows.map((data, index) => (
                    <div key={index}>
                      <ContentGroupList
                        stage={data}
                        rows={data}
                        index={index}
                        stage_id={data.id}
                        workspace_id={workspace_id}
                        updated_at={updated_at}
                        stage_name={data.name}
                        handleInlineEdit = {handleInlineEdit}
                        can_access_edit_title={can_access_edit_title}
                        can_access_assigned_user={can_access_assigned_user}
                        can_access_show_content_details={can_access_show_content_details}
                        can_access_move_content_list={can_access_move_content_list}
                        can_access_add_change_date={can_access_add_change_date}
                        can_access_approval_dots={can_access_approval_dots}
                        can_access_edit_label={can_access_edit_label}
                        can_access_move_stage_board={can_access_move_stage_board}
                        allowed_stages={stages}
                        getStages={getStages}
                        addContentGroupToStage={addContentGroupToStage}
                        loadNextPage={nextPage}
                        removeContentGroupToStage={removeContentGroupToStage}
                      />
                    </div>
                  ))}
                  {provided.placeholder}
                </div>
              )
            }}
          </Droppable>
        </DragDropContext>

        {
          stages?.length == 0  &&
          <div style={{ textAlign: 'center', marginTop: '2rem', marginBottom: '2rem' }}>
            <img src={ EmptyStage } className="text-center" style={{ width: "500px", maxWidth: '100%' }} />
            <p className="mt-3" style={{ fontWeight: '600', fontSize: '1.4rem' }}>This workspace has no stage yet.</p>
          </div>
        }

        {can_access_stage && (
          <div className="d-grid mt-5">
            <Button variant="dashed" className="mt-4 mt-lg-0 mb-4 h-36px" onClick={setNewStageFormPopup} size={'sm'}>
              Add Stage
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}


const mapStateToProps = (state) => {
  return {
    replace_image: state.content_group.replace_image,
    loading: (state.work_space.loading && state.content_group.loading)
  };
};

export default connect(mapStateToProps, {  })(ContentGroupsTables);
